import { render } from "./RButton.vue?vue&type=template&id=65bcc315&scoped=true"
import script from "./RButton.vue?vue&type=script&lang=js"
export * from "./RButton.vue?vue&type=script&lang=js"

import "./RButton.vue?vue&type=style&index=0&id=65bcc315&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bcc315"]])

export default __exports__